import { getTableProductCategory } from 'actions'
import NotificationError from 'components/common/notificationsErrors'
import { Form, Formik, FormikProps } from 'formik'
import { getInitValues } from 'lib/FieldValidations'
import React, { Component, Fragment } from 'react'
import { Alert, Button, Col, Row } from 'react-bootstrap'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import _ from 'underscore'
import {
	IPricesAndCostsFilterProps,
	IPricesAndCostsFilterState
} from '../../models/PricesAndCostsMassiveUploadInterface'
import PricesAndCostsMassiveUploadFilterFields from '../PricesAndCostsMassiveUpload/PricesAndCostsGlobalUploadFilterFields'

class PricesAndCostsFilter extends Component<
	IPricesAndCostsFilterProps,
	IPricesAndCostsFilterState
> {
	componentDidMount = () => {
		this.props.getTableProductCategory({ incluye_todos: 1 })
	}

	render() {
		const {
			t,
			fields,
			itemInfo,
			handleButtonClean,
			handleMapValues,
			handleSearchProviders,
			handleIsSearching,
			isSearching
		} = this.props

		const disableForm = false

		const initialValues =
			itemInfo || (fields.length ? getInitValues(fields) : {})

		return (
			<Formik
				initialValues={initialValues}
				onSubmit={(values, actions) => {
					handleMapValues(values)
				}}
				enableReinitialize={true}
				validationSchema={{}}
			>
				{(props: FormikProps<any>) => (
					<Fragment>
						<Col sm={12}>
							<NotificationError
								errors={props.errors}
								touched={props.touched}
							/>
						</Col>
						<Col sm={12}>
							<Alert variant={'dark'}>
								<b>{t('CRUDS.general_use.filters')}</b>
							</Alert>
						</Col>
						<Form className="container-fluid">
							<Row className="row justify-content-md-center">
								<Col sm={12} className={'text-center, mx-3'}>
									<Row>
										{!_.isEmpty(fields) &&
											_.map(fields, (field) => {
												return (
													<Col sm={3}>
														<PricesAndCostsMassiveUploadFilterFields
															field={field}
															formikProps={props}
															crudProps={this.props}
															initialValue={initialValues}
															handleIsSearching={handleIsSearching}
															isSearching={isSearching}
															searchProviders={handleSearchProviders}
														/>
													</Col>
												)
											})}
									</Row>
									<Row sm={12} className="row justify-content-md-center">
										{!disableForm && (
											<Button
												style={{
													minWidth: '145px',
													margin: '15px 30px 20px 0px'
												}}
												type={'submit'}
											>
												{t('Collection.form.buttons.apply')}
											</Button>
										)}
										{!disableForm && (
											<Button
												style={{
													minWidth: '145px',
													margin: '15px 30px 20px 0px'
												}}
												type={'button'}
												onClick={() => {
													props.resetForm()
													handleButtonClean()
												}}
											>
												{t('Collection.form.buttons.clean')}
											</Button>
										)}
									</Row>
								</Col>
							</Row>
						</Form>
					</Fragment>
				)}
			</Formik>
		)
	}
}
const mapStateToProps = ({ tableCalls }: any) => {
	const { productCategory } = tableCalls

	return {
		productCategory
	}
}

const connectForm = connect(mapStateToProps, {
	getTableProductCategory
})(PricesAndCostsFilter)

export default withTranslation()(withRouter(connectForm))
